import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { Entity } from '../../modules/dto'

export const dtoFeatureKey = 'dto'

/** Defines the state a loaded entity can be in (i.e. is it loaded fully or partial).
 */
export enum LoadingState {
  /** The entity was loaded completely from the backend. This is the default state. */
  Full,
  /** The entity was loaded partially as reference to another entity.
   * (This means, it will contain only the fields: id, type and _repre_)
   */
  Partial
}

/** A ngrx-store wrapper for a dto-entity. */
export class DtoWrapper {
  /** Identifier for ngrx-entities store. Format: [dtoType]_[id] (Bsp: Order_1)*/
  dtoKey: string
  dto: Entity
  /** Determines, if entity is already requested from the backend and in the progress of getting. */
  pending: boolean
  /** Defines the state of the dto-property (i.e. is it loaded fully or partial). */
  loadingState: LoadingState = LoadingState.Full
}

export interface DtoState extends EntityState<DtoWrapper> {}

export const dtoStateAdapter: EntityAdapter<DtoWrapper> = createEntityAdapter<DtoWrapper>({
  selectId: (dtoWrapper: DtoWrapper) => dtoWrapper.dtoKey
})

export const initialDtoState: DtoState = dtoStateAdapter.getInitialState({})
